'use strict';

/**
 * @ngdoc function
 * @name cimerFrontEndApp.controller:LoginCtrl
 * @description
 * # LoginCtrl
 * Controller of the cimerFrontEndApp
 */
angular.module('cimerFrontEndApp')
  .controller('LoginCtrl', ['$scope','$location','Session',function ($scope,$location,Session) {

      // if the user is already authenticated, show them the dashboard
      var sessionObject = Session.getSessionObject();
      if (sessionObject.isAuthenticated) {
          $location.url('/dashboard');
          return;
      }

      // Set the initial focus to the username/email field
      $('#username').focus();

      $scope.credentials = {
          username: '',
          password: '',
          surveyUser: false
      };

      $scope.user = {
          username: $scope.credentials.username,
          password: $scope.credentials.password,
          discipline: '',
          institution: '',
          position: ''
      };

      $scope.errMsg = '';
      $scope.loginPressed = false;

      $scope.login = function(credentials) {
          $scope.loginPressed = true;
          Session.authenticate(credentials.username,credentials.password)
            .then(function() {
                $scope.errMsg = '';
                //updating navbar settings using inherited scope object, see index.js
                $scope.navbarSettings = {
                    userAuthenticated: Session.isAuthenticated,
                    userName: Session.username
                };

                var sessionObject = Session.getSessionObject();

                //right now, this is only happening in the authorizedLink directive
                if (Session.redirectUrl != null) {
                    window.location = Session.redirectUrl;
                    Session.redirectUrl = null;
                }
                else {
                    $location.url('/dashboard');
                }
                $scope.loginPressed = false;
            }, function (responseData) {

                if (angular.isObject(responseData)) {

                    if (responseData.IsDeactivated) {
                        $scope.errMsg = 'Your account has been deactivated. Please reset your password.';
                    }
                    else if (responseData.IsLockedOut) {
                        $scope.errMsg = 'Too many failed login attempts. Please reset your password or wait 10 minutes and try again.';
                    }
                    else if (responseData.IsNotAllowed) {
                        $scope.errMsg = 'Your user is not allowed to log in.';
                    }
                    else {
                        $scope.errMsg = 'Invalid email or password entered.';
                    }
                    
                }
                else {
                    $scope.errMsg = 'Unknown error authenticating.';
                }

                $scope.loginPressed = false;

            });

      };


      $scope.createUser = function () {
          Session.createUser($scope.user)
          .then(function () {
              $location.url('/');
          }), function () {

              $scope.errMsg = 'Unable to create use' +
                  'r';
          };
      };

  }]);
